export default __webpack_public_path__ + "static/media/Grace 9781843628200.beffc6c0.jpg";